import { UserDto } from "../types/dto";
import { isBlast } from "./miscUtils";

export const escapeStringRegexp = (string: string) => {
	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};

export const formatBytes = (bytes = 0, decimals = 2) => {
	if (!+bytes) return "0B";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`;
};

export const dodgySearch = (value = "", searchStr = "") => {
	const trimmedValue = value.trim();
	const trimmedSearch = searchStr.trim();

	if (!trimmedSearch) return true;

	const guidRegex =
		/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

	if (guidRegex.test(trimmedSearch)) return true;

	// "Tech||Austin" => exact match either
	if (trimmedSearch.includes("||")) {
		const parts = trimmedSearch
			.split("||")
			.map((p) => p.trim())
			.filter(Boolean);
		return parts.some(
			(part) => trimmedValue.toLowerCase() === part.toLowerCase(),
		);
	}

	// "Tech|Austin" => contains either
	if (trimmedSearch.includes("|")) {
		const parts = trimmedSearch
			.split("|")
			.map((p) => p.trim())
			.filter(Boolean);
		return parts.some((part) =>
			trimmedValue.match(new RegExp(escapeStringRegexp(part), "i")),
		);
	}

	// Default: contains
	return trimmedValue.match(
		new RegExp(escapeStringRegexp(trimmedSearch), "i"),
	);
};

export const getInnerTextOfJWT = (obj: any) => {
	let buf = "";
	if (obj) {
		const type = typeof obj;
		if (type === "string" || type === "number") {
			buf += obj;
		} else if (type === "object") {
			let children = null;
			if (Array.isArray(obj)) {
				children = obj;
			} else {
				const props = obj.props;
				if (props) {
					children = props.children;
				}
			}
			if (children) {
				if (Array.isArray(children)) {
					children.forEach(function (o) {
						buf += getInnerTextOfJWT(o);
					});
				} else {
					buf += getInnerTextOfJWT(children);
				}
			}
		}
	}
	return buf;
};

export const formatLocaleDateString = (
	date: Date | undefined,
	isEmptyIfInvalid = true,
) => {
	const invalidString = isEmptyIfInvalid ? "" : "N/A";
	return (
		(date && new Date(date).toLocaleDateString(navigator.language)) ||
		invalidString
	);
};

export const formatLocaleTimeString = (
	date: Date | undefined,
	isEmptyIfInvalid = true,
) => {
	const invalidString = isEmptyIfInvalid ? "" : "N/A";
	return (
		(date && new Date(date).toLocaleTimeString(navigator.language)) ||
		invalidString
	);
};

export const formatLocaleDateAndTimeString = (
	date: Date | undefined,
	isEmptyIfInvalid = true,
) => {
	const invalidString = isEmptyIfInvalid ? "" : "N/A";
	return (
		(date && new Date(date).toLocaleString(navigator.language)) ||
		invalidString
	);
};

export const truncate = (str: string, maxLength: number) =>
	str.length > maxLength ? str.substr(0, maxLength - 1) + "..." : str;

export const convertCamelCaseToTitle = (text: string) => {
	if (!text) return "";
	const result = text.replace(/([A-Z])/g, " $1");
	const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
	return finalResult;
};

export const formatUserNameWithEmailString = ({
	firstName,
	lastName,
	email,
}: UserDto) => {
	const emailStr = email ? `<${email?.trim()?.toLowerCase()}>` : "";
	let nameStr = null;
	if (firstName) {
		nameStr = `${firstName?.trim() || ""} ${lastName?.trim() || ""}`;
	} else if (email) {
		nameStr = "Pending user activation";
	}

	return `${nameStr} ${emailStr}`;
};

export const WEBTITLE = isBlast ? "Austin Blast" : "Austin Cloud";
